import { stravaDao } from '../dao/strava-dao'

export const stravaService = {
  getAuthUrl: async (): Promise<string> => {
    const { authUrl } = await stravaDao.getAuthUrl()
    return authUrl
  },

  getConnectionStatus: async (): Promise<boolean> => {
    const { connected } = await stravaDao.getConnectionStatus()
    return connected
  },

  disconnect: async (): Promise<void> => {
    await stravaDao.disconnect()
  },
}
